import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'app/store'

export interface HoldingLimitTabsState {
  isFormChanged: {
    editCompanyLimit: boolean
  }
}

export const initialState: HoldingLimitTabsState = {
  isFormChanged: {
    editCompanyLimit: false
  }
}

export const holdingLimitTabsSlice = createSlice({
  name: 'holdingLimitTabs',
  initialState: initialState,
  reducers: {
    setIsFormChangedEditCompanyLimit: (state, action) => {
      state.isFormChanged.editCompanyLimit = action.payload
    },
    resetState: (state) => {
      state.isFormChanged = initialState.isFormChanged
    }
  }
})

export const {
  setIsFormChangedEditCompanyLimit,
  resetState
} = holdingLimitTabsSlice.actions

export const holdingLimitTabsSelector = (state: RootState) =>
  state.holdingLimitTabs

export default holdingLimitTabsSlice.reducer
